/**
 * The avatar marks' own colours (spec colour rule 5, DEVIATIONS D-07, S8c-3).
 *
 * A project's or a person's avatar bubble is a mark, like a brand mark: it
 * keeps the eight hues it has always had. Four of them (accent, blue, green,
 * yellow) are Ledger palettes already. The other four (purple, teal, cyan,
 * pink) have no Ledger token, so their two roles live here, at the values
 * the app's own ramps gave them before the restyle, and nothing else reads
 * them: `colorPalette="purple"` and friends draw the neutral palette
 * (`ledgerTheme.ts`), so a category can never borrow an avatar's hue.
 *
 * `emphasized` is the bubble's fill (its initial is drawn on it in white);
 * `subtle` the soft tint. This file is a documented exception to "tokens
 * only" and stays off Biome's strict list (DEVIATIONS, step 8 integration).
 */
import { defineConfig } from "@chakra-ui/react";

const mark = (light: string, dark: string) => ({
  value: { _light: light, _dark: dark },
});

export const avatarMarksConfig = defineConfig({
  theme: {
    semanticTokens: {
      colors: {
        avatar: {
          purple: {
            subtle: mark("#FAF5FF", "#322659"),
            emphasized: mark("#9F7AEA", "#553C9A"),
          },
          teal: {
            subtle: mark("#E6FFFA", "#1D4044"),
            emphasized: mark("#319795", "#285E61"),
          },
          cyan: {
            subtle: mark("#EDFDFD", "#065666"),
            emphasized: mark("#00B5D8", "#0987A0"),
          },
          pink: {
            subtle: mark("#FFF5F7", "#521B41"),
            emphasized: mark("#D53F8C", "#97266D"),
          },
        },
      },
    },
  },
});
